onReady(($) => {
    var acc = document.getElementsByClassName("drawer");

    for (let i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
            this.classList.toggle('active-drawer')
            var panel = this.nextElementSibling;
            if (panel.classList.contains('open')) {
                panel.classList.remove('open');
            }
            else {
                document.querySelectorAll(".panel")
                    .forEach(function (drawer) {
                        drawer.classList.remove("open");
                    })
                document.querySelectorAll(".drawer")
                    .forEach(function (closed) {
                        closed.classList.remove("active-drawer");
                    })
                panel.classList.add('open');
                this.classList.add('active-drawer')
            }
            // Adds a class IF count is present for copy alignment
            $(".drawer .count")
                .closest(".box")
                .addClass("with-count");
        });
    }
});
